import { Routes, RouterModule } from '@angular/router';
import { ConfirmDeactivateGuard } from '../../commons/guards';
import { CharitableContributionScreenComponent } from './charitable-contribution.component';

const charitableContributionRoutes: Routes = [];

export const CharitableContributionRouter = RouterModule.forChild(charitableContributionRoutes);